import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router-dom";

// For routing
function Redirect({ path, title }) {
  const history = useHistory();
  return (
    <button
      type="button"
      className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 xl-admin-btn"
      onClick={() => history.push(path)}
    >
      {title}
    </button>
  );
}

Redirect.propTypes = {
  path: PropTypes.string,
  title: PropTypes.string,
};
Redirect.defaultProps = {
  path: "",
  title: "",
};

export default Redirect;
